import { TextField, TextFieldProps } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useMemo } from 'react';
import { useEntityContext } from '../Entity.context';
import { ColumnSchema } from '../types/column-schema';

export interface EntityColumnSelectorProps {
  entity?: string;
  value?: string;
  disabled?: boolean;
  /** Override computed columns. */
  options?: Pick<ColumnSchema, 'columnName' | 'displayName'>[];
  textFieldProps?: Omit<TextFieldProps, 'variant'>;
  onChange?: (columnName?: string) => void;
}

const EntityColumnSelector: React.FC<EntityColumnSelectorProps> = ({
  entity,
  value,
  disabled,
  options: optionsProp,
  textFieldProps,
  onChange
}) => {
  const { schemas } = useEntityContext();

  const options = useMemo(() => {
    if (optionsProp) {
      return optionsProp;
    }
    const schema = entity
      ? schemas.find(schema => schema.name === entity)
      : undefined;
    return schema ? schema.columns : [];
  }, [optionsProp, entity, schemas]);

  const selected = useMemo(() => {
    return value
      ? options.find(option => option.columnName === value)
      : undefined;
  }, [options, value]);

  return (
    <Autocomplete
      className='field'
      options={options}
      disabled={disabled}
      value={selected || null}
      getOptionLabel={option => option.displayName}
      onChange={(_, value) => onChange?.(value?.columnName)}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label='Select Entity Column'
          {...textFieldProps}
          InputProps={{ ...params.InputProps, ...textFieldProps?.InputProps }}
          InputLabelProps={{
            ...params.InputLabelProps,
            ...textFieldProps?.InputLabelProps
          }}
        />
      )}
    />
  );
};
export default EntityColumnSelector;
